import { Head, usePage } from "@inertiajs/react";
import { Navbar } from "./Navbar";
import { MobileMenu } from "./MobileMenu";

interface LayoutProps {
  title?: string;
  user?: { email: string } | null;
  children: React.ReactNode;
}

export function Layout({ title, user, children }: LayoutProps) {
  const { url } = usePage();
  const isActive = (path: string) => url.startsWith(path);

  return (
    <div className="min-h-screen bg-background text-foreground">
      {title && <Head title={title} />}
      <Navbar user={user} />
      <main className="pb-16 md:pb-0">{children}</main>
      <MobileMenu isActive={isActive} />
    </div>
  );
}
